import { type FC } from 'react';
import * as React from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import PdpSharedShippingInfoWrapper from '../PdpSharedShippingInfo/PdpSharedShippingInfoWrapper';
import { PdpSharedDetailShipsFrom } from './PdpSharedDetailShipsFrom';

import { type PdpSharedDetailShipping_item$data as ItemType } from './__generated__/PdpSharedDetailShipping_item.graphql';
import { type PdpSharedDetailShipping_user$data as UserType } from './__generated__/PdpSharedDetailShipping_user.graphql';

type Props = {
    item: ItemType;
    user: UserType | null;
    userId?: string | null;
    currency: string;
    displayInline: boolean;
    preLinkQuoteDetails: React.ReactNode;
    postLinkQuoteDetails: React.ReactNode;
    isClient: boolean;
    postLinkNoQuoteDetails: React.ReactNode;
    itemQuantity?: number | null;
};

export const PdpSharedDetailsShippingComponent: FC<Props> = ({
    item,
    currency,
    user,
    displayInline,
    preLinkQuoteDetails,
    postLinkQuoteDetails,
    postLinkNoQuoteDetails,
    isClient,
    itemQuantity,
}) => {
    const { isSold, isUnpurchasable, isAuctionEnabled, isMultiSku, attributes } = item || {};
    const leadTime = attributes?.leadTime?.[0]?.option?.urlLabel;

    return (
        <>
            <PdpSharedShippingInfoWrapper
                user={user}
                item={item}
                currency={currency}
                leadTime={leadTime || ''}
                renderTooltip
                isClient={isClient}
                displayInline={displayInline}
                preLinkQuoteDetails={preLinkQuoteDetails}
                postLinkQuoteDetails={postLinkQuoteDetails}
                postLinkNoQuoteDetails={postLinkNoQuoteDetails}
                itemQuantity={itemQuantity}
                //calculate lower shipping info only if item is regular PDP
                calculateLowerShippingInfo={
                    !isSold && !isUnpurchasable && !isAuctionEnabled && !isMultiSku
                }
                positioning="seller_details"
            >
                <PdpSharedDetailShipsFrom item={item} />
            </PdpSharedShippingInfoWrapper>
        </>
    );
};

export const PdpSharedDetailShipping = createFragmentContainer(PdpSharedDetailsShippingComponent, {
    user: graphql`
        fragment PdpSharedDetailShipping_user on User {
            ...PdpSharedShippingInfoWrapper_user
        }
    `,
    item: graphql`
        fragment PdpSharedDetailShipping_item on Item {
            ...PdpSharedShippingInfoWrapper_item
            ...PdpSharedDetailShipsFrom_item

            isSold
            isUnpurchasable
            isAuctionEnabled
            isMultiSku
            attributes {
                leadTime {
                    option {
                        urlLabel
                    }
                }
            }
        }
    `,
});
